module.exports = __webpack_public_path__ + "c6bd0aae32b9932cf45f8ca840ffb1f0.png";